export const FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID =
  'FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID';
